import type { SlotComponentProps } from '../../types';

const IntentHeroBlock = ({ classification, context }: SlotComponentProps) => {
  return (
    <div className="rounded-3xl bg-gradient-to-br from-sky-50 via-white to-emerald-50 p-6 shadow-sm">
      <p className="mb-2 text-xs font-semibold uppercase tracking-[0.2em] text-sky-700">
        Intent-Driven Design Workspace
      </p>
      <h1 className="text-3xl font-bold text-slate-900">{classification.intent} interface composed on demand</h1>
      <p className="mt-3 max-w-3xl text-sm text-slate-600">
        Current query: <span className="font-medium text-slate-900">{context.query || 'No query provided yet'}</span>
      </p>
    </div>
  );
};

export default IntentHeroBlock;